import { Box, Tooltip, Typography } from '@mui/material';

const Copyright = () => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        pb: 3,
        mt: 'auto',
        textAlign: 'center',
      }}
    >
      <Tooltip title="Created By: Christopher Couture">
        <Box component="span" sx={{ display: 'inline-block' }}>
          <Typography variant="body2" color="text.secondary" component="span" display="block">
            © {process.env.NEXT_PUBLIC_ESTABLISHED} - {new Date().getFullYear()}{' '}
            {process.env.NEXT_PUBLIC_COMPANY}
          </Typography>
          <Typography variant="body2" color="text.secondary" component="span" display="block">
            All rights reserved.
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );
};

export default Copyright;
